import React from 'react';

const RefundStatusBadge = ({ refundStatus }) => {
  if (!refundStatus) return null;

  const statusConfig = {
    'Pending Approval': {
      color: 'bg-amber-100 text-amber-700',
      icon: 'fa-hourglass-half',
      label: 'Refund Pending Approval'
    },
    'Awaiting Admin Approval': {
      color: 'bg-blue-100 text-blue-700',
      icon: 'fa-hourglass-half',
      label: 'Awaiting Admin Approval'
    },
    'Awaiting SubAdmin Approval': {
      color: 'bg-blue-100 text-blue-700',
      icon: 'fa-hourglass-half',
      label: 'Awaiting SubAdmin Approval'
    },
    'Processing': {
      color: 'bg-cyan-100 text-cyan-700',
      icon: 'fa-spinner',
      label: 'Refund Processing'
    },
    'Completed': {
      color: 'bg-green-100 text-green-700',
      icon: 'fa-check-circle',
      label: 'Refund Completed'
    },
    'Rejected': {
      color: 'bg-red-100 text-red-700',
      icon: 'fa-times-circle',
      label: 'Refund Rejected'
    },
    'Failed': {
      color: 'bg-red-100 text-red-700',
      icon: 'fa-exclamation-circle',
      label: 'Refund Failed'
    }
  };

  const config = statusConfig[refundStatus.status] || statusConfig['Pending Approval'];

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${config.color}`}>
      <i className={`fa ${config.icon}`}></i>
      {config.label}
    </span>
  );
};

export default RefundStatusBadge;
